import { useFeature } from 'bv-hooks';
import { ReferAFriend, ReferAFriendAsia } from 'Index/features/routing/components/modal_routes/lazy_components';

export default () => {
  const [asiaRafEnabled] = useFeature('refer_a_friend_asia');
  const [rafEnabled] = useFeature('refer_a_friend');

  if (asiaRafEnabled) return <ReferAFriendAsia />;
  if (rafEnabled) return <ReferAFriend />;
  return null;
};
